import React, { isValidElement, useContext } from 'react';
import { observer } from 'mobx-react';
import StackLayout from '../../../stackLayout/StackLayoutComponent';
import TableContext from '../../tableContext/TableContext';
import Text from '../../../../core/text/TextComponent';
function TableColumn(_a) {
    var width = _a.width, stretch = _a.stretch, translateData = _a.translateData, noHeaderTranslation = _a.noHeaderTranslation, header = _a.header, data = _a.data;
    var tableContextInformation = useContext(TableContext);
    if (!tableContextInformation) {
        return null;
    }
    var mode = tableContextInformation.mode, columnIndex = tableContextInformation.columnIndex, model = tableContextInformation.model;
    var columnContent;
    if (mode === 'header') {
        columnContent = isValidElement(header) ? header : React.createElement(Text, { noTranslation: noHeaderTranslation }, header);
    }
    else {
        var dataContent = data(model);
        columnContent = isValidElement(dataContent) ? dataContent : React.createElement(Text, { noTranslation: !translateData }, dataContent);
    }
    return (React.createElement(StackLayout, { width: width, stretch: stretch, 
        // ToDo: Replace 2 with activeThemeVariant.columnSpacing
        marginLeft: columnIndex === 0 ? 0 : 2 }, columnContent));
}
export default observer(TableColumn);
//# sourceMappingURL=TableColumn.js.map